import type { QueryParams } from '~/types/api'
import type {
  PressDetail,
  PressPagedResult,
  PressSection,
  PressSectionPagedResult,
} from '~/types/api'

export function createPressesRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'presses'
  const DOMAIN_SECTIONS = 'press-sections'
  const LANG = 'press'
  const LANG_SECTIONS = 'sections'

  async function getAllPresses(params?: QueryParams) {
    return get<PressPagedResult>([DOMAIN], { params })
  }

  async function getPressDetail(id: number) {
    return get<PressDetail>([DOMAIN, id.toString()]) // TODO: ['base', LANG]
  }

  async function getAllSections(params?: QueryParams) {
    return get<PressSectionPagedResult>([DOMAIN_SECTIONS], { params })
  }

  async function getSection(id: number) {
    return get<PressSection>([DOMAIN_SECTIONS, id.toString()]) // TODO: langPath: ['base', LANG, LANG_SECTIONS]
  }

  return {
    getAllPresses,
    getPressDetail,
    getAllSections,
    getSection,
  }
}
